import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TimeLogFragment = { startTime: string, endTime?: string | null, userId: string, entityId: string, id: string, instruction?: string | null, user?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };


export type TimeLogFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type OngoingTimerFragment = { startTime: string, endTime?: string | null, userId: string, entityId: string, entityType: Types.TimeLogEntityTypeEnum, parentEntityId?: string | null, parentEntityType?: Types.TimeLogEntityTypeEnum | null, id: string };


export type OngoingTimerFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TimeLogsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.TimeLogsFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type TimeLogsQuery = { timeLogs: { edges?: Array<{ node: { startTime: string, endTime?: string | null, userId: string, entityId: string, id: string, instruction?: string | null, user?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null } }> | null } };

export const TimeLogFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeLog on TimeLogType {
  startTime
  endTime
  userId
  entityId
  id
  user {
    ...User
  }
  instruction
}
    `;
export const OngoingTimerFragmentDoc = /*#__PURE__*/ gql`
    fragment OngoingTimer on TimeLogType {
  startTime
  endTime
  userId
  entityId
  entityType
  parentEntityId
  parentEntityType
  id
}
    `;
export const TimeLogsDocument = /*#__PURE__*/ gql`
    query timeLogs($first: Float, $filters: TimeLogsFilters, $sort: [SortType!]) {
  timeLogs(first: $first, filters: $filters, sort: $sort) {
    edges {
      node {
        ...TimeLog
      }
    }
  }
}
    ${TimeLogFragmentDoc}
${UserFragmentDoc}`;

export function useTimeLogsQuery(options?: Omit<Urql.UseQueryArgs<TimeLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeLogsQuery, TimeLogsQueryVariables>({ query: TimeLogsDocument, ...options });
};